export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'Hqk0iUtpgr3RWpOixqIA7FzxmxnTViED',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'Hqk0iUtpgr3RWpOixqIA7FzxmxnTViED',
        audience: 'https://crew-time/api',
    }
}